import { render } from "./notice-setting.vue?vue&type=template&id=6e0236df"
import script from "./notice-setting.vue?vue&type=script&lang=js"
export * from "./notice-setting.vue?vue&type=script&lang=js"

import "./notice-setting.vue?vue&type=style&index=0&id=6e0236df&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__